<elder-nav-list class="flex">
  <elder-nav-link
    icon="dashboard"
    title="dashboard.title"
    routerLink="app/dashboard"
  ></elder-nav-link>

  <mat-divider></mat-divider>

  <elder-nav-link icon="assignment" title="jobs.title" routerLink="app/jobs"></elder-nav-link>

  <mat-divider></mat-divider>

  <elder-nav-link icon="settings" title="settings.title" routerLink="app/settings"></elder-nav-link>
</elder-nav-list>
